.label {
    --label-color: rgb(7, 141, 97);

    height: 19px;
    min-width: 0;
    max-width: 150px;
    display: inline-flex;
    align-items: center;
    flex: 0 1 auto;
    padding: 0 6px;
    gap: 5px;
    border-radius: 8px;
    background-color: color-mix(in srgb, var(--label-color) 12%, white);
    color: var(--label-color);
}

.labelBody {
    height: 24px;
    padding: 0 8px;
}

.clickable {
    cursor: pointer;
}

.pin {
    width: 4px;
    height: 4px;
    flex: 0 0 auto;
    border-radius: 999px;
    background-color: currentColor;
}

.text {
    min-width: 0;
    overflow: hidden;
    color: inherit;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.textBody {
    font-size: 12px;
}

.deleteButton {
    width: 12px;
    height: 12px;
    margin: 0 -2px 0 0;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
}

.deleteIcon {
    width: 12px;
    height: 12px;
}
